(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ww-policy-panels"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#ww-policy-"]');
    if (link) {
      const panel = document.getElementById(link.hash.slice(1));
      if (!panel) return;
      event.preventDefault();
      panel.showModal();
      return;
    }
    const close = event.target.closest('[data-policy-close]');
    if (close) close.closest('dialog').close();
    const cookieLink = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
    if (cookieLink) cookieLink.closest('.ww-policy-panel')?.close();
  });
  } catch(e) { console.error(e); }
})();

})();
